import React, { useState } from 'react';
type ModalType = 'privacy' | 'terms' | 'contact' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  const closeModal = () => setActiveModal(null);
  const modalContent = {
    privacy: {
      title: 'Política de Privacidad',
      content: <div className="space-y-4 text-sm" data-id="element-152">
          <p data-id="element-153">
            En DOG-CALM respetamos tu privacidad y protegemos tus datos
            personales.
          </p>
          <h3 className="font-bold text-base mt-4 text-white" data-id="element-154">
            1. Recopilación de datos
          </h3>
          <p data-id="element-155">
            Solo recopilamos los datos necesarios para procesar tu pedido
            (nombre, email y datos de pago a través de pasarelas seguras).
          </p>
          <h3 className="font-bold text-base mt-4 text-white" data-id="element-156">
            2. Uso de la información
          </h3>
          <p data-id="element-157">
            Tu email será utilizado exclusivamente para enviarte el acceso al
            producto adquirido y comunicaciones relacionadas.
          </p>
        </div>
    },
    terms: {
      title: 'Términos y Condiciones',
      content: <div className="space-y-4 text-sm" data-id="element-158">
          <p data-id="element-159">Al adquirir DOG-CALM, aceptas los siguientes términos:</p>
          <h3 className="font-bold text-base mt-4 text-white" data-id="element-160">
            1. Propiedad Intelectual
          </h3>
          <p data-id="element-161">
            El contenido es propiedad exclusiva de sus creadores. Queda
            prohibida su distribución o reventa.
          </p>
          <h3 className="font-bold text-base mt-4 text-white" data-id="element-162">
            2. Naturaleza del producto
          </h3>
          <p data-id="element-163">
            Este es un producto digital. El acceso se otorga de forma inmediata
            tras el pago.
          </p>
        </div>
    },
    contact: {
      title: 'Contacto',
      content: <div className="space-y-4 text-center py-4" data-id="element-164">
          <p data-id="element-165">¿Tienes alguna duda o problema con tu acceso?</p>
          <p data-id="element-166">Escríbenos a nuestro correo de soporte:</p>
          <a href="mailto:electronicecomjj@gmail.com" className="inline-block mt-4 px-6 py-3 bg-accent text-white font-bold rounded-full hover:bg-accent-dark transition-colors" data-id="element-167">
            electronicecomjj@gmail.com
          </a>
        </div>
    }
  };
  return <>
      <footer className="bg-charcoal-light py-12 text-center text-white/40 text-sm border-t border-white/5" data-id="element-168">
        <div className="max-w-lg mx-auto px-5" data-id="element-169">
          <p className="mb-6" data-id="element-170">
            © 2026 DOG-CALM. Todos los derechos reservados.
          </p>
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-3" data-id="element-171">
            <button onClick={() => setActiveModal('privacy')} className="hover:text-white transition-colors underline underline-offset-4" data-id="element-172">
              Política de Privacidad
            </button>
            <button onClick={() => setActiveModal('terms')} className="hover:text-white transition-colors underline underline-offset-4" data-id="element-173">
              Términos y Condiciones
            </button>
            <button onClick={() => setActiveModal('contact')} className="hover:text-white transition-colors underline underline-offset-4" data-id="element-174">
              Contacto
            </button>
          </div>
        </div>
      </footer>

      {/* Modal Overlay */}
      {activeModal && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-charcoal/90 backdrop-blur-sm animate-fade-in-up" style={{
      animationDuration: '0.2s'
    }} data-id="element-175">
          <div className="glass-strong rounded-2xl p-6 md:p-8 max-w-lg w-full max-h-[80vh] overflow-y-auto relative shadow-2xl border border-white/10" data-id="element-176">
            <button onClick={closeModal} className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center rounded-full bg-white/10 text-white/70 hover:bg-white/20 hover:text-white transition-colors" aria-label="Cerrar" data-id="element-177">
              ✕
            </button>
            <h2 className="text-xl font-bold mb-6 text-white border-b border-white/10 pb-4" data-id="element-178">
              {modalContent[activeModal].title}
            </h2>
            <div className="text-white/70" data-id="element-179">
              {modalContent[activeModal].content}
            </div>
          </div>
        </div>}
    </>;
}